module.exports = __webpack_public_path__ + "img/inside.f5750477.png";